<template>
  <div>
   <div class="box_mode content_wrapper">
      <br>
      <br>
      <br>
      <br>
      <section id="territorios">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-2"></div>
					<div class="col-md-8">
						<h2 class="text-center">Descargas</h2>
						<p class="text-center">En esta sección puedes descargar tablas de todos los datos mostrados en el Portal, en distintos formatos.</p>
					</div>
					<div class="col-md-2"></div>
				</div>
			</div>
			<hr>
		</section><br><br>
		<section id="territorio" class="bg-celeste">
			<div class="container" v-if="cifCorte && cifCorte.length">
				<div class="row justify-content-center">
					<div class="col-md-2"></div>
					<div class="col-md-8">
						<h3 class="text-center">Corte Suprema</h3>
					</div>
					<div class="col-md-2"></div>
				</div>
				<hr>
				<div class="row">
					<div v-for="(cifra, i) of cifCorte" v-bind:key="cifra + '' + cifra.TEXTO">
						<div :class="cifra.CLASE + ' text-center'">
							<div class="cards">
								<div class="cards-header">
									{{ cifra.TEXTO }}
								</div>
							<div class="cards-body">
								<p class="cards-text">{{ cifra.VALOR }}</p>
								<div class="tribunales">
									<ul class="sub">
										<li v-for="(anio_sel, index) in anios_select" v-bind:key="anio_sel.VALOR"><a class="link" v-on:click="SelAnio(anio_sel.VALOR, index, i)">{{ anio_sel.TEXTO }}</a></li>
									</ul>
									<a class="btn" href="#">{{ txt_sel[i] }}</a>
								</div>
								<div class="clearfix"></div>
									<div class="text-center">
										<button v-if="loadingCor[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cifra.LINK, i, 'CSV', 'Cor')">CSV</button>
										<button v-if="!loadingCor[i]" class="btn btn-naranjo" v-on:click="Descarga(cifra.LINK, i, 'CSV', 'Cor')">CSV</button>
										<button v-if="loadingCor[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cifra.LINK, i, 'XLS', 'Cor')">XLS</button>
										<button v-if="!loadingCor[i]" class="btn btn-naranjo" v-on:click="Descarga(cifra.LINK, i, 'XLS', 'Cor')">XLS</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- fin cards-->
				</div>
				<hr>
				</div>
				<div class="container" v-if="cifApe && cifApe.length">
					<div class="row justify-content-center">
						<div class="col-md-2"></div>
						<div class="col-md-8">
							<h3 class="text-center">Cortes de Apelaciones</h3>
						</div>
						<div class="col-md-2"></div>
					</div>
					<hr>
					<div class="row">
						<div v-for="(ciape, i) of cifApe" v-bind:key="ciape + '' + ciape.TEXTO">
							<div :class="ciape.CLASE + ' text-center'">
								<div class="cards">
									<div class="cards-header">
										{{ ciape.TEXTO }}
									</div>
								<div class="cards-body">
									<p class="cards-text">{{ ciape.VALOR }}</p>
									<div class="tribunales">
										<ul class="sub">
											<li v-for="(anio_sel, index) in anios_select" v-bind:key="anio_sel.VALOR"><a class="link" v-on:click="SelAnio(anio_sel.VALOR, index, i)">{{ anio_sel.TEXTO }}</a></li>
										</ul>
										<a class="btn" href="#">{{ txt_sel[i] }}</a>
									</div>
									<div class="clearfix"></div>
									<div class="text-center">
										<button v-if="loadingApe[i]" class="btn btn-naranjo-download" v-on:click="Descarga(ciape.LINK, i, 'CSV', 'Ape')">CSV</button>
										<button v-if="!loadingApe[i]" class="btn btn-naranjo" v-on:click="Descarga(ciape.LINK, i, 'CSV', 'Ape')">CSV</button>
										<button v-if="loadingApe[i]" class="btn btn-naranjo-download" v-on:click="Descarga(ciape.LINK, i, 'XLS', 'Ape')">XLS</button>
										<button v-if="!loadingApe[i]" class="btn btn-naranjo" v-on:click="Descarga(ciape.LINK, i, 'XLS', 'Ape')">XLS</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
				</div>
				<div class="container" v-if="cifTpi && cifTpi.length">
					<div class="row justify-content-center">
						<div class="col-md-2"></div>
						<div class="col-md-8">
							<h3 class="text-center">Resumen Tribunales - Información de Causas por Rol</h3>
						</div>
						<div class="col-md-2"></div>
					</div>
					<hr>
					<div class="row">
						<div v-for="(citpi, i) of cifTpi" v-bind:key="citpi + '' + citpi.TEXTO">
							<div :class="citpi.CLASE + ' text-center'">
								<div class="cards">
									<div class="cards-header">
										{{ citpi.TEXTO }}
									</div>
									<div class="cards-body">
										<p class="cards-text">{{ citpi.VALOR }}</p>
										<div class="tribunales">
											<ul class="sub">
												<li v-for="(anio_sel, index) in anios_select" v-bind:key="anio_sel.VALOR"><a class="link" v-on:click="SelAnio(anio_sel.VALOR, index, i)">{{ anio_sel.TEXTO }}</a></li>
											</ul>
											<a class="btn" href="#">{{ txt_sel[i] }}</a>
										</div>
										<div class="clearfix"></div>
										<div class="text-center">
											<button v-if="loadingTpi[i]" class="btn btn-naranjo-download" v-on:click="Descarga(citpi.LINK, i, 'CSV', 'Tpi')">CSV</button>
											<button v-if="!loadingTpi[i]" class="btn btn-naranjo" v-on:click="Descarga(citpi.LINK, i, 'CSV', 'Tpi')">CSV</button>
											<button v-if="loadingTpi[i]" class="btn btn-naranjo-download" v-on:click="Descarga(citpi.LINK, i, 'XLS', 'Tpi')">XLS</button>
											<button v-if="!loadingTpi[i]" class="btn btn-naranjo" v-on:click="Descarga(citpi.LINK, i, 'XLS', 'Tpi')">XLS</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
				</div>
				<div class="container" v-if="cifFam && cifFam.length">
					<div class="row justify-content-center">
						<div class="col-md-2"></div>
						<div class="col-md-8">
							<h3 class="text-center">Familia</h3>
						</div>
						<div class="col-md-2"></div>
					</div>
					<hr>
					<div class="row">
						<div v-for="(cifam, i) of cifFam" v-bind:key="cifam + '' + cifam.TEXTO">
							<div :class="cifam.CLASE + ' text-center'">
								<div class="cards">
									<div class="cards-header">
										{{ cifam.TEXTO }}
									</div>
									<div class="cards-body">
										<p class="cards-text">{{ cifam.VALOR }}</p>
										<div class="tribunales">
											<ul class="sub">
												<li v-for="(anio_sel, index) in anios_select" v-bind:key="anio_sel.VALOR"><a class="link" v-on:click="SelAnio(anio_sel.VALOR, index, i)">{{ anio_sel.TEXTO }}</a></li>
											</ul>
											<a class="btn" href="#">{{ txt_sel[i] }}</a>
										</div>
										<div class="clearfix"></div>
										<div class="text-center">
											<button v-if="loadingFam[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cifam.LINK, i, 'CSV', 'Fam')">CSV</button>
											<button v-if="!loadingFam[i]" class="btn btn-naranjo" v-on:click="Descarga(cifam.LINK, i, 'CSV', 'Fam')">CSV</button>
											<button v-if="loadingFam[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cifam.LINK, i, 'XLS', 'Fam')">XLS</button>
											<button v-if="!loadingFam[i]" class="btn btn-naranjo" v-on:click="Descarga(cifam.LINK, i, 'XLS', 'Fam')">XLS</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
				</div>
				<div class="container" v-if="cifCiv && cifCiv.length">
					<div class="row justify-content-center">
						<div class="col-md-2"></div>
						<div class="col-md-8">
							<h3 class="text-center">Civil</h3>
						</div>
						<div class="col-md-2"></div>
					</div>
					<hr>
					<div class="row">
						<div v-for="(ciciv, i) of cifCiv" v-bind:key="ciciv + '' + ciciv.TEXTO">
							<div :class="ciciv.CLASE + ' text-center'">
								<div class="cards">
									<div class="cards-header">
										{{ ciciv.TEXTO }}
									</div>
									<div class="cards-body">
										<p class="cards-text">{{ ciciv.VALOR }}</p>
										<div class="tribunales">
											<ul class="sub">
												<li v-for="(anio_sel, index) in anios_select" v-bind:key="anio_sel.VALOR"><a class="link" v-on:click="SelAnio(anio_sel.VALOR, index, i)">{{ anio_sel.TEXTO }}</a></li>
											</ul>
											<a class="btn" href="#">{{ txt_sel[i] }}</a>
										</div>
										<div class="clearfix"></div>
										<div class="text-center">
											<button v-if="loadingCiv[i]" class="btn btn-naranjo-download" v-on:click="Descarga(ciciv.LINK, i, 'CSV', 'Civ')">CSV</button>
											<button v-if="!loadingCiv[i]" class="btn btn-naranjo" v-on:click="Descarga(ciciv.LINK, i, 'CSV', 'Civ')">CSV</button>
											<button v-if="loadingCiv[i]" class="btn btn-naranjo-download" v-on:click="Descarga(ciciv.LINK, i, 'XLS', 'Civ')">XLS</button>
											<button v-if="!loadingCiv[i]" class="btn btn-naranjo" v-on:click="Descarga(ciciv.LINK, i, 'XLS', 'Civ')">XLS</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
				</div>
				<div class="container" v-if="cifLab && cifLab.length">
					<div class="row justify-content-center">
						<div class="col-md-2"></div>
						<div class="col-md-8">
							<h3 class="text-center">Laboral</h3>
						</div>
						<div class="col-md-2"></div>
					</div>
					<hr>
					<div class="row">
						<div v-for="(cilab, i) of cifLab" v-bind:key="cilab + '' + cilab.TEXTO">
							<div :class="cilab.CLASE + ' text-center'">
								<div class="cards">
									<div class="cards-header">
										{{ cilab.TEXTO }}
									</div>
									<div class="cards-body">
										<p class="cards-text">{{ cilab.VALOR }}</p>
										<div class="tribunales">
											<ul class="sub">
												<li v-for="(anio_sel, index) in anios_select" v-bind:key="anio_sel.VALOR"><a class="link" v-on:click="SelAnio(anio_sel.VALOR, index, i)">{{ anio_sel.TEXTO }}</a></li>
											</ul>
											<a class="btn" href="#">{{ txt_sel[i] }}</a>
										</div>
										<div class="clearfix"></div>
										<div class="text-center">
											<button v-if="loadingLab[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cilab.LINK, i, 'CSV', 'Lab')">CSV</button>
											<button v-if="!loadingLab[i]" class="btn btn-naranjo" v-on:click="Descarga(cilab.LINK, i, 'CSV', 'Lab')">CSV</button>
											<button v-if="loadingLab[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cilab.LINK, i, 'XLS', 'Lab')">XLS</button>
											<button v-if="!loadingLab[i]" class="btn btn-naranjo" v-on:click="Descarga(cilab.LINK, i, 'XLS', 'Lab')">XLS</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
				</div>
				<div class="container" v-if="cifCob && cifCob.length">
					<div class="row justify-content-center">
						<div class="col-md-2"></div>
						<div class="col-md-8">
							<h3 class="text-center">Cobranza</h3>
						</div>
						<div class="col-md-2"></div>
					</div>
					<hr>
					<div class="row">
						<div v-for="(cicob, i) of cifCob" v-bind:key="cicob + '' + cicob.TEXTO">
							<div :class="cicob.CLASE + ' text-center'">
								<div class="cards">
									<div class="cards-header">
										{{ cicob.TEXTO }}
									</div>
									<div class="cards-body">
										<p class="cards-text">{{ cicob.VALOR }}</p>
										<div class="tribunales">
											<ul class="sub">
												<li v-for="(anio_sel, index) in anios_select" v-bind:key="anio_sel.VALOR"><a class="link" v-on:click="SelAnio(anio_sel.VALOR, index, i)">{{ anio_sel.TEXTO }}</a></li>
											</ul>
											<a class="btn" href="#">{{ txt_sel[i] }}</a>
										</div>
										<div class="clearfix"></div>
										<div class="text-center">
											<button v-if="loadingCob[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cicob.LINK, i, 'CSV', 'Cob')">CSV</button>
											<button v-if="!loadingCob[i]" class="btn btn-naranjo" v-on:click="Descarga(cicob.LINK, i, 'CSV', 'Cob')">CSV</button>
											<button v-if="loadingCob[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cicob.LINK, i, 'XLS', 'Cob')">XLS</button>
											<button v-if="!loadingCob[i]" class="btn btn-naranjo" v-on:click="Descarga(cicob.LINK, i, 'XLS', 'Cob')">XLS</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
				</div>
				<div class="container" v-if="cifPen && cifPen.length">
					<div class="row justify-content-center">
						<div class="col-md-2"></div>
						<div class="col-md-8">
							<h3 class="text-center">Penal</h3>
						</div>
						<div class="col-md-2"></div>
					</div>
					<hr>
					<div class="row">
						<div v-for="(cipen, i) of cifPen" v-bind:key="cipen + '' + cipen.TEXTO">
							<div :class="cipen.CLASE + ' text-center'">
								<div class="cards">
									<div class="cards-header">
										{{ cipen.TEXTO }}
									</div>
									<div class="cards-body">
										<p class="cards-text">{{ cipen.VALOR }}</p>
										<div class="tribunales">
											<ul class="sub">
												<li v-for="(anio_sel, index) in anios_select" v-bind:key="anio_sel.VALOR"><a class="link" v-on:click="SelAnio(anio_sel.VALOR, index, i)">{{ anio_sel.TEXTO }}</a></li>
											</ul>
											<a class="btn" href="#">{{ txt_sel[i] }}</a>
										</div>
										<div class="clearfix"></div>
										<div class="text-center">
											<button v-if="loadingPen[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cipen.LINK, i, 'CSV', 'Pen')">CSV</button>
											<button v-if="!loadingPen[i]" class="btn btn-naranjo" v-on:click="Descarga(cipen.LINK, i, 'CSV', 'Pen')">CSV</button>
											<button v-if="loadingPen[i]" class="btn btn-naranjo-download" v-on:click="Descarga(cipen.LINK, i, 'XLS', 'Pen')">XLS</button>
											<button v-if="!loadingPen[i]" class="btn btn-naranjo" v-on:click="Descarga(cipen.LINK, i, 'XLS', 'Pen')">XLS</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
  </div>
</template>
<script>

import {
  mapState,
  mapActions,
} from 'vuex';
export default {
  methods: {
    ...mapActions([
      'actjuzgados',
      'actcortes',
      'actcifras',
    ]),
    SelAnio: function(a, index, pos) {
      // var largo = this.txt_sel
      // this.txt_sel = []
      // for (var j in largo){
      //	for (var i in this.anios_select) {
      //		if (this.anios_select[i].SELECCIONADO){
      //			this.txt_sel[j] = this.anios_select[i].TEXTO
      //		}
      //	}
      // }
      // this.txt_sel[pos] = this.anios_select[index].TEXTO
      window.vm.$set(this.txt_sel, pos, this.anios_select[index].TEXTO);
      window.vm.$set(this.val_sel, pos, a);
    },
    Descarga: function(link, pos, tipo, lug) {
      if (lug == 'Cor') {
        this.$set(this.loadingCor, pos, true);
      }
      if (lug == 'Ape') {
        this.$set(this.loadingApe, pos, true);
      }
      if (lug == 'Tpi') {
        this.$set(this.loadingTpi, pos, true);
      }
      if (lug == 'Fam') {
        this.$set(this.loadingFam, pos, true);
      }
      if (lug == 'Civ') {
        this.$set(this.loadingCiv, pos, true);
      }
      if (lug == 'Cob') {
        this.$set(this.loadingCob, pos, true);
      }
      if (lug == 'Lab') {
        this.$set(this.loadingLab, pos, true);
      }
      if (lug == 'Pen') {
        this.$set(this.loadingPen, pos, true);
      }

      this.axios.get(this.ipact + '/descargas' + link + this.val_sel[pos] + '-' + tipo + '.zip', {responseType: 'blob'})
          .then(({data}) => {
            const blob = new Blob([data], {type: 'application/zip'});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Download-' + this.val_sel[pos] + '.zip';
            link.click();
            if (lug == 'Cor') {
              this.$set(this.loadingCor, pos, false);
            }
            if (lug == 'Ape') {
              this.$set(this.loadingApe, pos, false);
            }
            if (lug == 'Tpi') {
              this.$set(this.loadingTpi, pos, false);
            }
            if (lug == 'Fam') {
              this.$set(this.loadingFam, pos, false);
            }
            if (lug == 'Civ') {
              this.$set(this.loadingCiv, pos, false);
            }
            if (lug == 'Cob') {
              this.$set(this.loadingCob, pos, false);
            }
            if (lug == 'Lab') {
              this.$set(this.loadingLab, pos, false);
            }
            if (lug == 'Pen') {
              this.$set(this.loadingPen, pos, false);
            }
          })
          .catch(function(error) {

          });
    },
  },
  mounted() {
    this.axios.get(this.ipapi + 'cifras_clave/descargas/suprema/2018')
        .then((response) => {
          this.cifCorte = response.data;
          this.txt_total = this.cifCorte.length;
          for (let i = 0; i < this.cifCorte.length; i++) {
            this.loadingCor[i] = false;
          }
        })
        .catch(function(error) {

        });
    this.axios.get(this.ipapi + 'cifras_clave/descargas/apelaciones/2018')
        .then((response) => {
          this.cifApe = response.data;
          this.txt_total = this.txt_total + this.cifApe.length;
          for (let i = 0; i < this.cifApe.length; i++) {
            this.loadingApe[i] = false;
          }
        })
        .catch(function(error) {

        });
    this.axios.get(this.ipapi + 'cifras_clave/descargas/primera/2018')
        .then((response) => {
          this.cifTpi = response.data;
          this.txt_total = this.txt_total + this.cifTpi.length;
          for (let i = 0; i < this.cifTpi.length; i++) {
            this.loadingTpi[i] = false;
          }
        })
        .catch(function(error) {

        });
    this.axios.get(this.ipapi + 'cifras_clave/descargas/familia/2018')
        .then((response) => {
          this.cifFam = response.data;
          this.txt_total = this.txt_total + this.cifFam.length;
          for (let i = 0; i < this.cifFam.length; i++) {
            this.loadingFam[i] = false;
          }
        })
        .catch(function(error) {

        });
    this.axios.get(this.ipapi + 'cifras_clave/descargas/civil/2018')
        .then((response) => {
          this.cifCiv = response.data;
          this.txt_total = this.txt_total + this.cifCiv.length;
          for (let i = 0; i < this.cifCiv.length; i++) {
            this.loadingCiv[i] = false;
          }
        })
        .catch(function(error) {

        });
    this.axios.get(this.ipapi + 'cifras_clave/descargas/laboral/2018')
        .then((response) => {
          this.cifLab = response.data;
          this.txt_total = this.txt_total + this.cifLab.length;
          for (let i = 0; i < this.cifLab.length; i++) {
            this.loadingLab[i] = false;
          }
        })
        .catch(function(error) {

        });
    this.axios.get(this.ipapi + 'cifras_clave/descargas/cobranza/2018')
        .then((response) => {
          this.cifCob = response.data;
          this.txt_total = this.txt_total + this.cifCob.length;
          for (let i = 0; i < this.cifCob.length; i++) {
            this.loadingCob[i] = false;
          }
        })
        .catch(function(error) {

        });
    this.axios.get(this.ipapi + 'cifras_clave/descargas/penal/2018')
        .then((response) => {
          this.cifPen = response.data;
          this.txt_total = this.txt_total + this.cifPen.length;
          for (let i = 0; i < this.cifPen.length; i++) {
            this.loadingPen[i] = false;
          }
        })
        .catch(function(error) {

        });
    this.axios.get(this.ipapi + 'select_anios/Select')
        .then((response) => {
          this.anios_select = response.data;
          for (const i in this.anios_select) {
            if (this.anios_select[i].SELECCIONADO) {
              for (let j = 0; j < this.txt_total; j++) {
                this.val_sel[j] = this.anios_select[i].VALOR;
                this.txt_sel[j] = this.anios_select[i].TEXTO;
              }
            }
          }
        })
        .catch(function(error) {

        });
  },
  components: { },
  data() {
    return {
      loadingCor: [],
      loadingApe: [],
      loadingTpi: [],
      loadingFam: [],
      loadingCiv: [],
      loadingCob: [],
      loadingLab: [],
      loadingPen: [],
      anios_select: [],
      txt_sel: [],
      val_sel: [],
      cifCorte: [],
      cifApe: [],
      cifTpi: [],
      cifFam: [],
      cifCiv: [],
      cifLab: [],
      cifCob: [],
      cifPen: [],
      txt_total: 0,
      ubicacion: 0,
    };
  },
  computed: {
    ...mapState([
      'juzgados',
      'cortes',
      'cifras',
      'ipapi',
      'ipact',
    ]),
  },
};
</script>
<style src="vue-slim-tabs/themes/default.css"></style>
<style>

/*cardsss*/
.cards{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip: border-box;
    border: 0px solid rgba(0,0,0,.125);
    border-radius: .85rem; margin-bottom: 10px;}
.cards>hr{margin-right:0;margin-left:0}
.cards>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.85rem;border-top-right-radius:.85rem}
.cards>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.85rem;border-bottom-left-radius:.85rem}
.cards-body{-ms-flex:1 1 auto;flex:1 1 auto;padding:1.25rem}
.cards-title{margin-bottom:.75rem}
.cards-subtitle{margin-top:-.375rem;margin-bottom:0}
.cards-text:last-child{margin-bottom:0}
.cards-link:hover{text-decoration:none}
.cards-link+.cards-link{margin-left:1.25rem}
.cards-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:#3c4c9b;border-bottom:1px solid rgba(0,0,0,.125); color: #fff;}
.cards-header:first-child{border-radius:calc(.85rem - 1px) calc(.85rem - 1px) 0 0}
.cards-header+.list-group .list-group-item:first-child{border-top:0}
.cards-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.cards-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.cards-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.cards-header-pills{margin-right:-.625rem;margin-left:-.625rem}.cards-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.cards-img{width:100%;border-radius:calc(.25rem - 1px)}.cards-img-top{width:100%;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.cards-img-bottom{width:100%;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.cards-deck{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.cards-deck .cards{margin-bottom:15px}@media (min-width:576px){.cards-deck{-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.cards-deck .cards{display:-ms-flexbox;display:flex;-ms-flex:1 0 0%;flex:1 0 0%;-ms-flex-direction:column;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.cards-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.cards-group>.cards{margin-bottom:15px}@media (min-width:576px){.cards-group{-ms-flex-flow:row wrap;flex-flow:row wrap}.cards-group>.cards{-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.cards-group>.cards+.cards{margin-left:0;border-left:0}.cards-group>.cards:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.cards-group>.cards:first-child .cards-header,.cards-group>.cards:first-child .cards-img-top{border-top-right-radius:0}.cards-group>.cards:first-child .cards-footer,.cards-group>.cards:first-child .cards-img-bottom{border-bottom-right-radius:0}.cards-group>.cards:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.cards-group>.cards:last-child .cards-header,.cards-group>.cards:last-child .cards-img-top{border-top-left-radius:0}.cards-group>.cards:last-child .cards-footer,.cards-group>.cards:last-child .cards-img-bottom{border-bottom-left-radius:0}.cards-group>.cards:only-child{border-radius:.25rem}.cards-group>.cards:only-child .cards-header,.cards-group>.cards:only-child .cards-img-top{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.cards-group>.cards:only-child .cards-footer,.cards-group>.cards:only-child .cards-img-bottom{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.cards-group>.cards:not(:first-child):not(:last-child):not(:only-child){border-radius:0}.cards-group>.cards:not(:first-child):not(:last-child):not(:only-child) .cards-footer,.cards-group>.cards:not(:first-child):not(:last-child):not(:only-child) .cards-header,.cards-group>.cards:not(:first-child):not(:last-child):not(:only-child) .cards-img-bottom,.cards-group>.cards:not(:first-child):not(:last-child):not(:only-child) .cards-img-top{border-radius:0}}.cards-columns .cards{margin-bottom:.75rem}@media (min-width:576px){.cards-columns{-webkit-column-count:3;-moz-column-count:3;column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.cards-columns .cards{display:inline-block;width:100%}}.accordion .cards:not(:first-of-type):not(:last-of-type){border-bottom:0;border-radius:0}.accordion .cards:not(:first-of-type) .cards-header:first-child{border-radius:0}.accordion .cards:first-of-type{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.accordion .cards:last-of-type{border-top-left-radius:0;border-top-right-radius:0}
.cards select{
	display: inline-block;
	border: 2px solid #3f51b5;
    background-color: #fff;
    color: #666;
    border-radius: 19px;
    padding: 10px 10px;
    height: 38px;
	position: relative;
	float: right;
}

</style>
